import React, {
  FC,
  useState,
} from 'react';
import styled from 'styled-components';
import {
  Popover as MaterialPopover,
  Typography,
} from '@material-ui/core';

import { Nullable } from '@/core/interfaces/common';

const PopoverText = styled(Typography)`
  padding: 10px 20px;
`;

interface PopoverProps {
  children: React.ReactNode;
  shouldDisplayPopover: boolean;
  text: string;
}

export const Popover: FC<PopoverProps> = ({
  children,
  shouldDisplayPopover,
  text,
}) => {
  const [
    anchorEl,
    setAnchorEl,
  ] = useState<Nullable<Element>>(null);

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handlePopoverOpen = (event: React.MouseEvent<HTMLDivElement, globalThis.MouseEvent>) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <>
      <div
        onMouseEnter={event => shouldDisplayPopover && handlePopoverOpen(event)}
        onMouseLeave={handlePopoverClose}
      >
        {children}
      </div>
      <MaterialPopover
        id="mouse-over-popover--send-button"
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        style={{ pointerEvents: 'none' }}
        anchorOrigin={{
          horizontal: 'left',
          vertical: 'top',
        }}
        transformOrigin={{
          horizontal: 'right',
          vertical: 'bottom',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <PopoverText>{text}</PopoverText>
      </MaterialPopover>
    </>
  );
};
